"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { isFormula } from '@membranehq/sdk';
import { EditorTagBadge } from './EditorTagBadge/index.mjs';
import { forwardRef } from 'react';
import { useComboBox } from '../context/use-combobox.mjs';
import { ComboBoxFormulaBadge } from './ComboBoxFormulaBadge.mjs';
import { ComboBoxSchemaValueBadge } from './ComboBoxSchemaValueBadge.mjs';
import { isDefinedValue } from './isDefinedValue.mjs';

const ComboBoxValueBadge = forwardRef(function({ placeholder, isDropdownOpen, disabled, onClick, className, onDelete }, ref) {
  const { value, variablesSchema, schema, options: staticOptions } = useComboBox();
  const isValueDefined = isDefinedValue(value);
  if (isDropdownOpen && (!isValueDefined || value === "")) {
    return /* @__PURE__ */ jsx(EditorTagBadge, { ref, className, variant: "ghost" });
  }
  if (isValueDefined) {
    if (isFormula(value)) {
      return /* @__PURE__ */ jsx(
        ComboBoxFormulaBadge,
        {
          ref,
          value,
          variablesSchema,
          disabled,
          onClick,
          className,
          onDelete
        }
      );
    }
    if (staticOptions) {
      const selectedOption = staticOptions.find((option) => option.value === value);
      if (selectedOption) {
        return /* @__PURE__ */ jsx(
          EditorTagBadge,
          {
            ref,
            disabled,
            className,
            variant: "value",
            onDelete,
            onClick,
            children: selectedOption.label
          }
        );
      }
    }
    return /* @__PURE__ */ jsx(
      ComboBoxSchemaValueBadge,
      {
        ref,
        value,
        schema,
        variablesSchema,
        disabled,
        onClick,
        className,
        onDelete
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className,
      role: "button",
      tabIndex: 0,
      onClick,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      },
      children: placeholder
    }
  );
});
ComboBoxValueBadge.displayName = "ComboBoxValue";

export { ComboBoxValueBadge };
